import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TimelineEvent } from './timeline-list.component';

@Component({
  selector: 'timeline-item',
  styleUrls: ['./timeline-item.component.scss'],
  templateUrl: './timeline-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimelineItemComponent {
  constructor() {}

  contentSize: { width: number; height: number };

  @Input() event: TimelineEvent;
  @Input() first: boolean = false;
  @Input() last: boolean = false;
  @Input() showTooltip: boolean = true;
}
